import fileDownload from 'js-file-download'
import { toJS } from 'mobx'
import ExcelJS from 'exceljs'

export const exportDistributeVoteExcel = async (
  assetStatisticList,
  currentDate
) => {
  try {
    const assetTypeNames = assetStatisticList?.assetTypeNames || []
    const data = toJS(assetStatisticList?.statisticsResponses)
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Báo cáo sử dụng văn phòng phẩm')
    const endCell = String.fromCharCode(65 + assetTypeNames.length + 3)

    // Thêm tiêu đề và các thông tin khác
    worksheet.mergeCells(`A1:${endCell}1`)
    worksheet.getCell(
      'A1'
    ).value = `BÁO CÁO SỬ DỤNG VĂN PHÒNG PHẨM THÁNG ${currentDate}`
    worksheet.getCell('A1').alignment = {
      vertical: 'middle',
      horizontal: 'center',
    }
    worksheet.getCell('A1').font = { size: 14, bold: true }
    worksheet.getCell('A2').value = ''

    const headerNameRowOne = [
      'STT',
      'Tên đơn vị',
      ...assetTypeNames.map(type => type),
      'Tổng thuế trước',
      'Tổng thuế sau',
    ]

    //Tính độ rộng cho ô tiêu đề
    function calculateHeaderWidth(header) {
      return header.length + 5
    }

    worksheet.addRow(headerNameRowOne)
    // Áp dụng border cho các ô tiêu đề
    const borderStyle = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }

    // Áp dụng border cho từng ô trong dòng tiêu đề đầu tiên
    headerNameRowOne.forEach((_, colIndex) => {
      // @ts-ignore
      worksheet.getCell(3, colIndex + 1).border = borderStyle
      worksheet.getRow(3).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }
      worksheet.getRow(3).font = { bold: true }
      if (colIndex == 1) {
        worksheet.getColumn(colIndex + 1).width =
          calculateHeaderWidth(headerNameRowOne[colIndex]) + 20
      } else {
        worksheet.getColumn(colIndex + 1).width = calculateHeaderWidth(
          headerNameRowOne[colIndex]
        )
      }
    })
    if (Array.isArray(data)) {
      // eslint-disable-next-line no-unused-expressions
      data?.forEach((record, index) => {
        const assetTypeData = {}
        if (Array.isArray(record.assetTypeList)) {
          assetTypeNames.forEach(type => {
            let found = false
            record.assetTypeList.forEach(asset => {
              if (asset.name && asset.name === type) {
                assetTypeData[asset.name] = asset.quantity
                found = true
              }
            })
            if (!found) {
              assetTypeData[type] = '----'
            }
          })
        } else {
          assetTypeNames.forEach(type => {
            assetTypeData[type] = '----'
          })
        }
        const dataRow = [
          index + 1,
          record?.departmentName,
          ...Object.values(assetTypeData),
          record?.preTax || 0,
          record?.afterTax || 0,
        ]
        const rowItem = worksheet.addRow(dataRow)
        rowItem.eachCell({ includeEmpty: true }, cell => {
          // @ts-ignore
          cell.border = borderStyle
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          if (Number(cell.col) >= 3) {
            cell.numFmt = '#,##0'
          }
        })
      })
    }

    const totalRow = worksheet.addRow([
      'Tổng cộng',
      '',
      ...assetStatisticList?.totalAssetTypes.map(type => parseFloat(type)),
      assetStatisticList?.totalPreTax || 0,
      assetStatisticList?.totalAfterTax || 0,
    ])
    worksheet.mergeCells(totalRow.number, 1, totalRow.number, 2)
    totalRow.eachCell({ includeEmpty: true }, (cell, colIndex) => {
      // @ts-ignore
      cell.border = borderStyle
      cell.alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      }
      cell.font = { bold: true }
      if (Number(colIndex) >= 3) {
        cell.numFmt = '#,##0';
      }
    })
    //tên file excel
    const parts = currentDate.split('-')
    const month = parseInt(parts[0], 10)
    const year = parseInt(parts[1], 10)
    const filename = `Bao_cao_su_dung_van_phong_pham_thang_${month}_${year}.xlsx`
    const buffer = await workbook.xlsx.writeBuffer()
    fileDownload(buffer, filename)
  } catch (error) {
    console.log('export asset statistic excel', error)
  }
}
